// PWA-Bootstrap: Service-Worker-Registrierung + Install-Prompt-Verwaltung.
let deferredPrompt = null;
const listeners = new Set();

const CACHE_GEN = "eg-pwa-v2"; // muss zu VERSION in public/sw.js passen

// Alte PWA-Caches (z. B. das frühere orange Design) einmalig HART entfernen
// und die Seite neu laden, damit sofort das aktuelle Design erscheint.
async function purgeOutdatedCaches() {
  if (!("caches" in window)) return;
  try {
    const keys = await caches.keys();
    const outdated = keys.filter((k) => !k.startsWith(CACHE_GEN));
    if (!outdated.length) return;
    await Promise.all(outdated.map((k) => caches.delete(k)));
    const reg = await navigator.serviceWorker?.getRegistration();
    await reg?.update();
    if (!sessionStorage.getItem("eg_cache_purged")) {
      sessionStorage.setItem("eg_cache_purged", "1");
      window.location.reload();
    }
  } catch { /* best effort */ }
}

export function registerPwa() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then(() => purgeOutdatedCaches())
      .catch(() => {});
  });
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function onInstallableChange(fn) {
  listeners.add(fn);
  fn(!!deferredPrompt);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((fn) => fn(false));
  return outcome; // "accepted" | "dismissed"
}

export function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}
